'use strict'

class Carousel {
  constructor() {
  	this.carousel_block = null;
    this.carousels = null;
    this.type= null;
  }

  init() {
  	this.carousel_block = document.querySelectorAll('.tps-carousel');
  	if (this.carousel_block.length) {
  		for(i=0;i<this.carousel_block.length;i++) {
  			this.carousels = this.carousel_block[i].querySelectorAll('.tps-carousel-items');	
      	if (this.carousels.length){
      		this.class = this.carousel_block[i].classList
					this.type = this.class.contains('video') ? 'video' : this.class.contains('image-only') ? 'image-only' : 'image';
					this.disable_card_design = this.class.contains('card-design-disabled') ? 'card-design-disabled' : '' ;
					this.rounded_image_style = this.class.contains('rounded-image-style') ? 'rounded-image' : '' ;
					this.full_width = this.class.contains('full-width') ? 'full-width' : '';
      		// this.type = this.carousel_block[i].classList.contains('video') ? 'video' : 'image';
        	this.initCarousels();
        }
  		}
  	}      
  }

  initCarousels() {
    const self = this;
    if (self.full_width == 'full-width') {
    	var items_count = '1';
    	var stagePaddingTab = 0;
    	var stagePaddingDes = 0;
    } else {
    	var items_count = (self.type=='video' || self.type=='image-only' ||  self.disable_card_design=='card-design-disabled') ? 1 : 2,
    			stagePaddingTab = (self.disable_card_design=='card-design-disabled' && self.rounded_image_style != 'rounded-image') ? 210 : 100,
    			stagePaddingLap = (self.disable_card_design=='card-design-disabled' && self.rounded_image_style != 'rounded-image') ? 400 : 230,
    			stagePaddingDes = (self.disable_card_design=='card-design-disabled' && self.rounded_image_style != 'rounded-image') ? 310 : 230,
    			stagePaddingLarge = (self.rounded_image_style == 'rounded-image') ? 400 : 510,
    			stagePaddingExtraLarge = (self.rounded_image_style == 'rounded-image') ? 400 : 630;

    }
              
		self.carousels.forEach(function(carousel) {
			const owl = jQuery(carousel);
			const owlPrev = carousel.parentNode.querySelector('.tps-carousel-items-nav-prev');
			const owlNext = carousel.parentNode.querySelector('.tps-carousel-items-nav-next');
			const $dotsContainer = carousel.parentNode.querySelector('.tps-carousel-items-nav-dots');
			owl.owlCarousel({
				nav: false,
				dots: true,
				dotsContainer: $dotsContainer,
				margin: 20,
				autoplay: (self.disable_card_design=='card-design-disabled') ? true : false,
				responsive: {
					0: {    
						items: 1,
					},
					768: {
						stagePadding: stagePaddingTab,
						loop: true,
						items: items_count,
					},
					1024: {
						stagePadding: stagePaddingDes,
						loop: true,
						items: items_count,
					},
					1250: {
						stagePadding: stagePaddingLap,
						loop: true,
						items: items_count,
					},
					1600: {
						stagePadding: (self.disable_card_design=='card-design-disabled') ? stagePaddingLarge  : stagePaddingDes,
						loop: true,
						items: items_count,
					},
					2000: {
						stagePadding: (self.disable_card_design=='card-design-disabled') ? stagePaddingExtraLarge  : stagePaddingDes,
						loop: true,
						items: items_count,
					},
				}
			});

			owlPrev.addEventListener('click', function(e) {
				owl.trigger('prev.owl.carousel');
			});

			owlNext.addEventListener('click', function(e) {
				owl.trigger('next.owl.carousel');
			});
		});
	}
}

